export default __webpack_public_path__ + "static/media/img_1.8b6a0e74.jpg";